import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { TableActionsPanel } from "app/pages/sales-intelligence/common-components/table-actions-panel";

export const StyledActionsPanel = styled(TableActionsPanel)`
    position: sticky;
    top: 160px;
    justify-content: flex-start;
    background-color: ${colorsPalettes.carbon["0"]};
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    border-top: 1px solid ${colorsPalettes.carbon["50"]};
`;
